export enum MapInfoInputField {
  Name = 'name',
  Description = 'description',
  CustomMapUrl = 'custom_map_url',
  Password = 'privacy_level.password'
}
